import "./backbutton.scss";

import React, { Component } from "react";

export default class BackButton extends Component {
  render() {
    return (
      <div className="right-container" onClick={() => this.props.onClick()}>
        <i className="fa fa-arrow-left"></i>
      </div>
    );
  }
}
